import React from 'react';
import VideoClip from './VideoClip';

export default class VisualContent extends React.Component {
    render() {
        return (
            <section className="visual-content-container">
                <figure>
                    <VideoClip
                        url={this.props.video}
                        />
                </figure>
                <article>
                    {this.props.footerOne && <p>{this.props.footerOne}</p>}
                    {this.props.footerTwo &&
                        <div className="acknowledgements">
                            <p>{this.props.footerTwo.title} </p><a href={this.props.footerTwo.url}>{this.props.footerTwo.linkText}</a>
                        </div>
                    }
                </article>
            </section>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/VisualContent.js